import React, { useEffect, useRef, useState } from "react";
import JobPostPanel from "./JobPostPanel";
import ChatBoxHeader from "./ChatBoxHeader";
import {useDispatch, useSelector} from "react-redux";
import staffAvatar from '../../../../assets/img/noAvatarAdmin.svg'
import staffAvatarText from '../../../../assets/img/noAvatarAdminText.svg'
import talentAvatar from '../../../../assets/img/noAvatar.png'
import {
  setMessages, setChatList,
  sendMessage, setIsSameChatSelected, setMessageSendFrom, setTextInput,
  setIsMessageFormDirty, setFiles, setIsNewCompanyConversation, setIsFlagFilter
} from "reducers/chatMessage";
import {ThunkDispatch} from "@reduxjs/toolkit";
import {formatChatSendTime, formatDateTimeExcludeYear, formatName} from "utils/format";
import CustomToast from "components/CustomToast";
import {useSnackbar} from "notistack";
import {MAX_FILE_SIZE, MESSAGE_TYPE} from '../../../constants/index';
import CustomTextarea from "../../../components/CustomTextarea";
import CustomIconButton from "../../../components/CustomIconButton";
import { format, isToday } from "date-fns";
import { SYSTEM_USER_NAME, CHAT_USER_ROLE, MESSAGE_SEND_FROM } from "../../../constants/index";
import CustomButton from "../../../components/CustomButton";
import LinkifyCustom from "../../../components/LinkifyCustom";
import i18n from 'i18next';
import { downloadFileAttachment } from "../../../utils/util";


const ChatBox = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  let {staffInfo} = useSelector((state: any) => state.currentUser)
  const { chatSelected, isChatting, talentSelected, jobSelected, isOpenListJobPanel, messages, actionStatus, actionName,
    isScout, chatList, messageSendFrom, textInput, files, isSuccess, error, isNewChat } = useSelector((state: any) => state.chatMessage);

  const [messageInput, setMessageInput] = useState("");
  const scrollableDivRef = useRef<HTMLDivElement>(null);
  const [isDebounced, setIsDebounced] = useState(false);
  const inputRef = useRef(null);
  const unreadMessageRef = useRef<HTMLDivElement>(null);
  const [showGoToButton, setShowGoToButton] = useState(false);
  const [talentActive, setTalentActive] = useState(true);

  useEffect(() => {
    if(isNewChat) {
      setTalentActive(true);
    }
  }, [isNewChat])

  useEffect(() => {
    if(talentSelected && talentSelected?.id && typeof talentSelected?.is_active === "boolean") {
        setTalentActive(talentSelected?.is_active);
      }
  }, [talentSelected])

  const checkIfInView = () => {
    const container = scrollableDivRef.current;
    const target = unreadMessageRef.current;

    if (!container || !target) return;

    const containerRect = container.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();

    // Check unread message ref outside container ref
    const isOutOfView =
      targetRect.top < containerRect.top ||
      targetRect.bottom - 5 > containerRect.bottom;

      setShowGoToButton(isOutOfView && messages?.length > 0 && chatSelected.latest_unread_message_id && chatSelected.latest_unread_message_id != messages[0].id && messages[0].id != -1);
  };

  useEffect(() => {
    if(messages?.length == 0) {
      return
    }
    setShowGoToButton(false)
    setTimeout(() => {
      checkIfInView();
    }, 1000); // Delay to render
    
  }, [messages]);

  const handleClickAttachmentIcon = () => {
    if (inputRef) {
      const inputRefCurrent: any = inputRef.current;
      if (inputRefCurrent) {
        inputRefCurrent.click();
      }
    }
  };

  const attachmentIcon = {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <mask id="mask0_14620_4767" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9" /></mask>
        <g mask="url(#mask0_14620_4767)"><path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H13V5H5V19H19V11H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM6 17H18L14.25 12L11.25 16L9 13L6 17ZM17 9V7H15V5H17V3H19V5H21V7H19V9H17Z" fill="currentColor" /></g>
      </svg>
    ),
    onClick: handleClickAttachmentIcon
  };

  const handleEnterSendMessage = (event: any) => {
    if (event.key === "Enter") {
      if (isDebounced) {
        console.log("Chat so fast, Pls wait...");
        return;
      }
      setIsDebounced(true);
      event.preventDefault();
      handleSendMessage()
      setTimeout(() => {
        clearInput();
        setIsDebounced(false);
      }, 500);
    }
  }

  const showToast = (title: any, mes: any, variant: any) => {
    enqueueSnackbar("I love snacks.", {
      autoHideDuration: 7000,
      content: (key) => (
        <CustomToast title={title} message={mes} variant={variant}
          snackbarKey={key} closeSnackbar={closeSnackbar} />
      ),
    });
  };

  const handleDownloadFileAttachment = async (url: string, filename?: string) => {
    try {
      await downloadFileAttachment(url, filename);
    } catch (error) {
      showToast("メッセージ", i18n.t('MSG_GLOBAL_FILE_NOT_EXIST_OR_DELETED'), "error");
    }
  };

  const handleSendNewMessage = () => {
    dispatch(setTextInput(messageInput));
    handleSendMessage();
  }

  const handleSendMessage = () => {
    if (!textInput.trim() && files.length == 0) return;
    if (isScout && !jobSelected?.id) {
      showToast("メッセージ", i18n.t('MSG_CHAT_JOB_INFOMATION_REQUIRED'), "error")
      return;
    }

    const data = {
      files: files,
      chat_conversation_id: chatSelected?.id ? chatSelected?.id : null,
      talent_id: talentSelected?.talent?.id,
      job_id: isScout ? jobSelected?.id : null,
      type: isScout ? MESSAGE_TYPE.SCOUT : MESSAGE_TYPE.COMPANY_DISCUSS,
      content: textInput.trim(),
      message_send_from: messageSendFrom,
    }
    dispatch(setIsSameChatSelected(true));
    dispatch(sendMessage({formData: data}));
    dispatch(setMessageSendFrom(MESSAGE_SEND_FROM.CHAT));
    if(!chatSelected?.id) {
      dispatch(setIsNewCompanyConversation(true));
      dispatch(setIsFlagFilter(false));
    } else {
      const isFlagged = chatSelected?.user_chat?.flags?.includes(staffInfo.user_id);
      if (!isFlagged) {
        dispatch(setIsFlagFilter(false));
      }
    }

    const newMessages:any[] = [...messages];
    const newM = {
        "id": -1,
        "user": { "id": staffInfo.id, "first_name": staffInfo.first_name, "last_name": staffInfo.last_name, "avatar": staffInfo.avatar, "user_id": staffInfo.user_id },
        "content": textInput.trim(),
        "send_at": new Date(),
        "files": [],
        "user_role": CHAT_USER_ROLE.STAFF,
        "user_chat": {
            "flags": [],
            "reads": [staffInfo.user_id]
        },
    }
    newMessages.unshift(newM);
    dispatch(setMessages(newMessages));
    dispatch(setIsMessageFormDirty(false));

    clearInput();
  };

  const clearInput = () => {
    dispatch(setTextInput(""));
    setMessageInput("");
    dispatch(setFiles([]));
  }

  const scrollToBottom = () => {
    setTimeout(() => {
      if (scrollableDivRef.current) {
        scrollableDivRef.current.scrollTo({
          top: scrollableDivRef.current.scrollHeight,
        });
      }
    }, 300); // Delay to render
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Show toast
  useEffect(() => {
    if (actionStatus === 'fulfilled' && actionName === 'sendMessage') {
      scrollToBottom();

      if(!isSuccess) {
        showToast("メッセージ", error, "error")
      }
    }
  }, [actionStatus, actionName]);

  const handleUploadImage = (e: any) => {
    dispatch(setIsMessageFormDirty(true));
    let filesTmp = Array.from(e.target.files);

    if (filesTmp.length + files.length > 3) {
      showToast("メッセージ", i18n.t('MSG_CHAT_MAX_ATTACHMENT_EXCEEDED'), "error")
      e.target.value = null;
      return;
    }
    for (const fileInput of filesTmp) {
      if (fileInput instanceof File) {
        // Check file size
        const sizeInMB = fileInput.size / (1024 * 1024);
        if (sizeInMB > MAX_FILE_SIZE.MESSAGE) {
          showToast("メッセージ", i18n.t('MSG_CHAT_MAX_ATTACHMENT_SIZE_EXCEEDED'), "error");
          filesTmp = filesTmp.filter(file => file.name !== fileInput.name);
        }
      }
    }
    if (filesTmp.length > 0) {
      filesTmp.push(...files);
      dispatch(setFiles(filesTmp));
    }
    e.target.value = null;
  };

  // Check disable submit
  const isDisabled: boolean = !talentSelected?.id;

  const handleScrollToUnread = () => {
    unreadMessageRef.current?.scrollIntoView({ behavior: 'smooth' })
    setShowGoToButton(false)

    if(messages?.length > 0 && chatSelected?.id) {
      const newChatList = chatList.map(item =>
        item.id == chatSelected.id ? { ...item, latest_unread_message_id: messages[0].id } : item
      );
      dispatch(setChatList(newChatList));
    }
  };

  const handleDisableButtonSend = () => {
    if(!talentSelected?.id) {
      return true
    }
    if(!textInput && !files.length) {
      return true
    }
    if(isScout && !jobSelected?.id) {
      return true
    }

    return false
  };

  return (
    <div className="relative h-full w-full p-4 bg-white rounded-lg rounded-bl-none flex flex-col">
      {isChatting && <ChatBoxHeader />}
      {isChatting && (chatSelected.id ? <div className="relative overflow-hidden flex-1 bg-[#F7F7F7] flex flex-col justify-between gap-[0.625rem] p-2 pt-4">
        <div ref={scrollableDivRef} className="flex flex-col-reverse gap-6 overflow-y-auto custom-scrollbar custom-html-style" >
        {showGoToButton && (
          <CustomButton
            onClick={handleScrollToUnread}
            size="sm"
            variant="outline"
            customStyle="absolute top-2 left-1/2 -translate-x-1/2 z-10 !gap-1"
          >
            <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="currentColor"><path d="m291-192-51-51 240-240 240 240-51 51-189-189-189 189Zm0-285-51-51 240-240 240 240-51 51-189-189-189 189Z"/></svg>
            未読メッセージ
          </CustomButton>
          )}

        {isChatting && chatSelected.id &&
          <>
              {messages?.map((message: any, idx: any) => (
                <div ref={chatSelected.latest_unread_message_id && messages.length > 1 && idx < messages.length - 1 && messages[idx+1].id == chatSelected.latest_unread_message_id ? unreadMessageRef : null} key={idx} className={`mt-4 w-full flex items-start gap-2 ${message.is_from_system ? "" : message.user?.user_id == staffInfo.user_id && message?.user_role == CHAT_USER_ROLE.STAFF ? "justify-end" : ""}`} >
                  {(message.is_from_system || message.user?.user_id != staffInfo.user_id || message?.user_role != CHAT_USER_ROLE.STAFF) &&
                    <div className="w-10 h-10 relative shrink-0">
                      {message.is_from_system || message?.user_role != CHAT_USER_ROLE.STAFF ? <img className="w-full h-full object-cover rounded-full"
                          src={message.user?.avatar ? message.user?.avatar :  talentAvatar}
                          alt="other-avatar"/> : 
                        <>
                          <img className="w-full h-full object-cover rounded-full"
                            src={message.user?.avatar ? message.user?.avatar :  staffAvatar}
                            alt="other-avatar"/>
                          {!message.user?.avatar && <img src={staffAvatarText} alt="" className="absolute left-0 bottom-0 w-5 h-[0.625rem]" />}
                        </>
                      }
                    </div>
                  }
                  <div className="max-w-[75%]">
                    <div className={`flex items-center ${message.is_from_system ? "" : message.user?.user_id == staffInfo.user_id && message?.user_role == CHAT_USER_ROLE.STAFF ? "justify-end" : ""} gap-2`}>
                      <p className="!m-0 text-sm font-bold alu-text-base-2">
                        {message.is_from_system ? SYSTEM_USER_NAME : formatName(message.user?.first_name, message.user?.last_name)}{message.user_role == "staff" && !message.is_from_system ? '（' + staffInfo?.company?.name + '）' : ''}
                      </p>
                      <p className="!m-0 text-sm alu-text-base-1">
                        {formatDateTimeExcludeYear(message.send_at)}
                      </p>
                    </div>
                    <div className="ml-auto flex flex-col gap-2">
                      {message?.content && (
                        <p className={`!m-0 w-auto whitespace-pre-wrap break-all px-2 py-[0.375rem] rounded-lg text-sm text-white ${message.is_from_system ? "whitespace-pre-wrap break-all bg-white alu-text-base-2" : message.user?.user_id == staffInfo.user_id && message?.user_role == CHAT_USER_ROLE.STAFF ? "bg-[#2182BA]" : "whitespace-pre-wrap break-all bg-white alu-text-base-2"}`}>
                          <LinkifyCustom text={message.content} isSentByMe={message.user?.user_id == staffInfo.user_id && message?.user_role == CHAT_USER_ROLE.STAFF} />
                        </p>
                      )}
                      {message.files?.length > 0 && (
                        <div className="rounded-lg flex flex-col gap-4 text-sm">
                          {message.files?.map((file: any, idx: any) =>
                            file?.file_type === "image" ? (
                              <img key={idx} src={file?.file_path} alt={file?.file_name} className="max-w-[22.5rem] h-auto object-fit rounded" />
                            ) : (
                              <div onClick={() => handleDownloadFileAttachment(file?.file_path, file?.file_name)} key={idx} className="hover:cursor-pointer flex items-center justify-between gap-4 border border-[#E0E0E0] rounded px-3 py-1 text-sm group bg-white hover:bg-[#FFF3E5] active:bg-[#FFF3E5] focus:bg-transparent focus:outline focus:outline-1 focus:outline-[#FF861A]">
                                <p className="truncate alu-text-base-2 group-hover:text-[#B35400] group-active:text-[#B35400] group-focus::text-[#B35400]">{file?.file_name}</p>
                                <CustomIconButton variant="icononly" customStyle="shrink-0 fill-[#808080] group-hover:fill-[#FF861A] group-active:fill-[#B35400] group-focus::fill-[#808080]">
                                  <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" height="20px" viewBox="0 0 24 24" width="20px">
                                    <g><rect fill="none" height="24" width="24" /></g>
                                    <g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z"/></g>
                                  </svg>
                                </CustomIconButton>
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  {!message.is_from_system && message.user?.user_id == staffInfo.user_id && message?.user_role == CHAT_USER_ROLE.STAFF &&
                    <div className="w-10 h-10 relative shrink-0">
                      <img className="w-full h-full object-cover rounded-full" 
                      src={message.user?.avatar ? message.user?.avatar : staffAvatar} alt="my-avatar" />
                      {!message.user?.avatar && <img src={staffAvatarText} alt="" className="absolute left-0 bottom-0 w-5 h-[0.625rem]" />}
                    </div>
                  }
                </div>
              ))}
            </>
        }
        </div>
        {talentActive ? <div className={`shrink-0 p-2 pb-[0.625rem] bg-white rounded-lg`}>
          <input
            disabled={isDisabled}
            ref={inputRef}
            type="file"
            className="hidden"
            name="image"
            id="image"
            multiple
            accept=".jpg,jpeg,.png,.pdf"
            onChange={handleUploadImage}
          />
          <div className="flex gap-2 relative">
            <p className="hidden md:block absolute -bottom-2 left-0 alu-text-base-1 text-[0.625rem] leading-[0.9375rem]">shift + Enter キーで送信</p>
            <div className="relative flex-1">
              <CustomTextarea
                isResizable={false}
                disabled={isDisabled}
                scrollbarHidden={true}
                startIcon={attachmentIcon}
                id="message"
                name="message"
                value={textInput}
                rows={3}
                maxLines={5}
                onChange={(e: any) => {dispatch(setTextInput(e.target.value)); dispatch(setIsMessageFormDirty(true));}}
                onKeyDown={(e:any) => {
                  if (e.key === "Enter") {
                    if (e.shiftKey) {
                      // Prevent default behavior and send message with Shift + Enter
                      e.preventDefault();
                      handleEnterSendMessage(e);
                    } else {
                      return;
                    }
                  }
                }}
                placeholder="入力してください"
              />
            </div>
            <CustomButton
              disabled={isDisabled || !textInput && !files.length}
              onClick={handleSendMessage}
              customStyle="!shrink-0 !px-[0.5625rem]"
              size="md"
            >
              送信
            </CustomButton>
          </div>
          {Array.isArray(files) && files?.length > 0 && (
            <div className="mt-4 flex items-center gap-4 flex-wrap">
              {files?.map((file:any, idx) =>
                file?.type.startsWith("image/") ? (
                  <div className="w-12 h-12 relative" key={idx}>
                    <button
                      className="absolute top-[-8px] right-[-8px] w-4 h-4 bg-[#FF861A] rounded-full flex items-center justify-center"
                      onClick={() => {
                        const filteredFiles = files?.filter((item, index) => idx !== index);
                        dispatch(setFiles(filteredFiles))
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_14189_11449)">
                          <path
                            d="M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z"
                            fill="#343A3D"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_14189_11449">
                            <rect width="12" height="12" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                    <img
                      className="w-full h-full object-cover rounded-lg"
                      src={URL.createObjectURL(file)}
                      alt={`img-${idx}`}
                    />
                  </div>
                ) : (
                  <div
                    key={idx}
                    className="flex items-center py-1 px-2 border border-[#E0E0E0] rounded gap-4 text-sm"
                  >
                    <p className="truncate alu-text-base-2">{file?.name}</p>
                    <CustomIconButton
                      size="sm"
                      onClick={() => {
                        const filteredFiles = files?.filter((item, index) => idx !== index);
                        dispatch(setFiles(filteredFiles))
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" >
                        <g clipPath="url(#clip0_14189_11449)">
                          <path d="M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z" fill="currentColor"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_14189_11449">
                            <rect width="12" height="12" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </CustomIconButton>
                  </div>
                )
              )}
            </div>
          )}
          </div>
            :
          <div className={`shrink-0 p-4 bg-white rounded-lg`}>
            <p className="alu-text-base-1 text-base">退会済みのためメッセージは送信できません</p>
          </div>}
      </div>
        : 
      <div className="overflow-hidden flex-1 flex flex-col mt-2">
        <label className="block text-sm alu-text-base-2 font-bold mb-2">本文</label>
        <div className={`relative border border-[#E0E0E0] rounded-[0.25rem] focus-within:border-[#FF861A] flex-1 flex flex-col`}>
        {talentActive ?
          <>
          <CustomTextarea
            size="lg"
            id="message"
            name="message"
            isResizable={false}
            maxLines={10}
            value={textInput}
            onChange={(e: any) => {dispatch(setTextInput(e.target.value)); dispatch(setIsMessageFormDirty(true));}}
            placeholder="入力してください"
            customStyles="!rounded-b-none !p-4 border-0 !h-full"
            containerStyles="flex-1"
          />

          {Array.isArray(files) && files?.length > 0 && (
            <div className="flex items-center gap-4 flex-wrap w-full pt-2 p-4">
              {files?.map((file:any, idx) =>
                file?.type.startsWith("image/") ? (
                  <div className="w-12 h-12 relative" key={idx}>
                    <button
                      className="absolute top-[-8px] right-[-8px] w-4 h-4 bg-[#FF861A] rounded-full flex items-center justify-center"
                      onClick={() => {
                        const filteredFiles = files?.filter((item, index) => idx !== index);
                        dispatch(setFiles(filteredFiles))
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_14189_11449)">
                          <path
                            d="M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z"
                            fill="#343A3D"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_14189_11449">
                            <rect width="12" height="12" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                    <img
                      className="w-full h-full object-cover rounded-lg"
                      src={URL.createObjectURL(file)}
                      alt={`img-${idx}`}
                    />
                  </div>
                ) : (
                  <div
                    key={idx}
                    className="flex items-center py-1 px-2 border border-[#E0E0E0] rounded gap-4 text-sm"
                  >
                    <p className="truncate alu-text-base-2">{file?.name}</p>
                    <CustomIconButton
                      size="sm"
                      onClick={() => {
                        const filteredFiles = files?.filter((item, index) => idx !== index);
                        dispatch(setFiles(filteredFiles))
                      }}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" >
                        <g clipPath="url(#clip0_14189_11449)">
                          <path d="M9.5 3.205L8.795 2.5L6 5.295L3.205 2.5L2.5 3.205L5.295 6L2.5 8.795L3.205 9.5L6 6.705L8.795 9.5L9.5 8.795L6.705 6L9.5 3.205Z" fill="currentColor"/>
                        </g>
                        <defs>
                          <clipPath id="clip0_14189_11449">
                            <rect width="12" height="12" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </CustomIconButton>
                  </div>
                )
              )}
            </div>
          )}

          <div className={`px-4 py-[0.625rem] border-t border-t-[#E0E0E0]`}>
            <input
              ref={inputRef}
              type="file"
              className="hidden"
              name="image"
              id="image"
              multiple
              accept=".jpg,jpeg,.png,.pdf"
              onChange={handleUploadImage}
            />
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <CustomIconButton onClick={() => inputRef.current.click()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <mask id="mask0_14620_4767" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" fill="#D9D9D9" /></mask>
                    <g mask="url(#mask0_14620_4767)"><path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H13V5H5V19H19V11H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM6 17H18L14.25 12L11.25 16L9 13L6 17ZM17 9V7H15V5H17V3H19V5H21V7H19V9H17Z" fill="currentColor" /></g>
                  </svg>
                </CustomIconButton>
              </div>
              <div>
                <CustomButton
                  disabled={handleDisableButtonSend()}
                  size="md"
                  onClick={handleSendMessage}
                  customStyle="!shrink-0 !w-[87px]"
                >
                  送信
                </CustomButton>
              </div>
            </div>
          </div>

          </>
          :
          <p className="alu-text-base-1 text-base">退会済みのためメッセージは送信できません</p>
          }
        </div>

      </div>
      )}
      {!isChatting && <div className="bg-[#F7F7F7] w-full h-full flex items-center justify-center">
        <p className="text-[#000] text-sm font-bold">左のリストからメッセージを選択してください</p>  
      </div>}
      {isOpenListJobPanel && (<div className="fixed right-2 top-2 bottom-2 z-[999]"><JobPostPanel/></div>)}
    </div>
  );
};

export default ChatBox;